import React, { useEffect } from 'react';
import { PageLoader as CommonPageLoader } from '@gjensidige/se-page-loader';
import { useAppSelector } from '../../../hooks/appHooks';

export const PageLoader: React.FunctionComponent<{children: React.ReactNode}> = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isCreateOfferComplete = useAppSelector(
    (state) =>
      state.insurance.loading !== 'pending' &&
      state.insurance.loading !== 'idle'
  );
  if (!isCreateOfferComplete) {
    return <CommonPageLoader loadingMessage="Ett litet ögonblick bara..." />;
  } else {
    return <>{children}</>;
  }
};
